export type AdminAccountType = "USER" | "ADMIN";

// Role slug provided by GET /manage/trials (e.g. "full_access").
export type AdminStudyPermissionAccess = string;

export type AdminStudyPermission = {
  id: string;
  trialId: string;
  studyLabel: string;
  access: AdminStudyPermissionAccess;
};

export type AdminStudyOption = {
  id: string;
  label: string;
  roles: string[];
};

export type AdminInvitedBy = {
  name: string;
  isVivo: boolean;
};

export type AdminUser = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  accountType: AdminAccountType;
  invitedOn: string;
  invitedBy: AdminInvitedBy;
  canDeactivate: boolean;
  studyPermissions: AdminStudyPermission[];
};

export const adminAccountTypeOptions: AdminAccountType[] = ["USER", "ADMIN"];
